<template>
  <div class="tile is-child has-background-dark tile-border">
    <DashboardPanel>
      <div class="panel-heading has-text-centered has-text-white custom-panel-heading">
        INSURER MESSAGES
      </div>

      <DashboardProgressBar :is-loading="isLoading"
        :initial-color="'#fff'"
        :loading-color="'#d90951'" />

      <div class="has-background-dark tile-border">
        <DashboardPnet v-if="pnet"
          :pnet="pnet"
          :is-uninvoiced-jobs-and-chart-disabled="isUninvoicedJobsAndChartDisabled"
          class="custom-panel-border" />
        <DashboardOrm v-if="orm"
          :orm="orm"
          :is-uninvoiced-jobs-and-chart-disabled="isUninvoicedJobsAndChartDisabled"
          class="custom-panel-border" />
        <DashboardEstimage v-if="estimage"
          :estimage="estimage"
          :is-uninvoiced-jobs-and-chart-disabled="isUninvoicedJobsAndChartDisabled"
          class="custom-panel-border" />
      </div>
    </dashboardpanel>
  </div>
</template>

<script>
import DashboardService from '@/views/dashboard/DashboardService'
import DashboardPanel from '@/views/dashboard/DashboardPanel.vue'
import DashboardProgressBar from '@/views/dashboard/DashboardProgressBar.vue'
import { Columns } from '@/views/pnetmessage/columns'
import DashboardOrm from './DashboardOrm.vue'
import DashboardPnet from './DashboardPnet.vue'
import DashboardEstimage from './DashboardEstimage.vue'

export default {
  name: 'DashboardInsurerMessages',
  components: { DashboardProgressBar, DashboardPanel, DashboardOrm, DashboardPnet, DashboardEstimage },

  props: {
    isUninvoicedJobsAndChartDisabled: Boolean
  },
  data() {
    return {
      pnet: null,
      orm: null,
      estimage: null,
      isLoading: false,
      timeOutId: 0,
      filter: {
        quoteNo: '',
        rego: '',
        claimNo: '',
        messageTypeId: 0,
        messageStatusId: this.tab,
        sortColumn: Columns[Columns.length - 2].name,
        sortOrder: Columns[Columns.length - 2].defaultOrder,
        pageIndex: 1,
        pageSize: 18
      }
    }
  },
  computed: {},
  created() {
    this.constantlyUpdateData()
  },
  beforeDestroy() {
    if (this.timeOutId) clearTimeout(this.timeOutId)
  },
  methods: {
    async getData() {
      this.isLoading = true
      this.orm = await DashboardService.getDashboardOrmStatus()
      this.pnet = await DashboardService.getDashboardPnetStatus()
      this.estimage = await DashboardService.getDashboardEstimageStatus()
      this.isLoading = false
    },
    constantlyUpdateData() {
      this.getData()
      // we want to update the data every 5 minutes
      this.timeOutId = setTimeout(this.constantlyUpdateData, 1000 * 300)
    }
  }
}
</script>

<style scoped>

.custom-panel-border:not(:last-child) {
  border-bottom: 1px solid black;
}

.tile-border {
  border-radius: 20px !important;
}

.custom-panel-heading {
  border-radius: 20px 20px 0 0 !important;
  background-color: #495057 !important;
}
</style>